import React from "react";
import { emojis, stickers } from "../../global-components/src/utils/text";

interface ReactionEmojiProps {
    emoji: string;
    className?: string;
    size?: number;
}

export const ReactionEmoji: React.FC<ReactionEmojiProps> = ({ emoji, className = "", size = 16 }) => {
    // Check if it's a Paçoca custom sticker or emoji code (e.g. :pacoca_coracao:, pacoca_coracao, etc.)
    const code = emoji.startsWith(":") ? emoji : `:${emoji}:`;
    const customHtml = emojis[code] || stickers[code] || emojis[emoji] || stickers[emoji];

    if (customHtml) {
        // Extract src from the img tag
        const match = customHtml.match(/src=['"]([^'"]+)['"]/);
        if (match && match[1]) {
            return (
                <img
                    src={match[1]}
                    alt={emoji}
                    className={`reaction-custom-emoji-img ${className}`}
                    style={{ width: size, height: size, objectFit: "contain", verticalAlign: "middle" }}
                />
            );
        }
        return <span className={className} dangerouslySetInnerHTML={{ __html: customHtml }} />;
    }

    return <span className={`reaction-unicode-emoji ${className}`}>{emoji}</span>;
};
